import { render } from "./CommandItem.vue?vue&type=template&id=43abd6ec&scoped=true"
import script from "./CommandItem.vue?vue&type=script&lang=js"
export * from "./CommandItem.vue?vue&type=script&lang=js"

import "./CommandItem.vue?vue&type=style&index=0&id=43abd6ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-43abd6ec"

export default script